export default __webpack_public_path__ + "static/media/6.a5805b2b.svg";